const CONSTANTS = {
    //URL: "http://localhost:3001/graphql",
    URL: "https://service.idict.io/graphql",
    PUBLISHABLE_KEY: "pk_live_51N7bRgASUUluU0ETRb1aYgxwODOtS7TSbJWp3bhjw8iA3YrpKFuq4UmmMx6O5uAFtWh9KND1idRZc0NsuXP1JyU600wesohVEv"
}

export default CONSTANTS;